import React from 'react'
import axios from 'axios'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import { withStyles } from '@material-ui/core/styles'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.min.css'

import { API } from '../../utils/constants'
import styles from './styles'

class Enquiry extends React.Component {
  state = {
    formdata: {
      type: '',
      name: '',
      company: '',
      mobile: '',
      email: '',
      months: '',
      project: '',
    },
  }

  onChange = e => {
    let formdata = this.state.formdata
    formdata[e.target.id] = e.target.value
    this.setState({ formdata: formdata })
  }

  submitForm = post => {
    let formdata = this.state.formdata
    let payload = {
      mtype: 'Project',
      template: 'project',
      type: this.props.type,
      name: formdata.name,
      company: formdata.company,
      mobile: formdata.mobile,
      email: formdata.email,
      months: formdata.months,
      project: formdata.project,
      resources: this.props.data,
    }

    axios.post(API.enquiry, payload).then(response => {
      toast.success('Your enquiry has been sent, thanks.')
    })

  }

  render() {
    const { classes, data, type } = this.props
    const { formdata } = this.state


    return (
      <div className={classes.enquiry}>
        <ToastContainer />

        <div className={classes.contents}>
          <form noValidate autoComplete="off">
            <TextField
              id="name"
              label="Name"
              margin="normal"
              fullWidth={true}
              value={formdata.name}
              onChange={e => this.onChange(e)}
            />
            <TextField
              id="company"
              label="Company Name"
              margin="normal"
              fullWidth={true}
              value={formdata.company}
              onChange={e => this.onChange(e)}
            />
            <TextField
              id="mobile"
              label="Mobile"
              margin="normal"
              fullWidth={true}
              value={formdata.mobile}
              onChange={e => this.onChange(e)}
            />
            <TextField
              id="email"
              label="Email"
              margin="normal"
              value={formdata.email}
              fullWidth={true}
              onChange={e => this.onChange(e)}
            />
            <TextField
              id="months"
              label="Months Required"
              margin="normal"
              value={formdata.months}
              fullWidth={true}
              onChange={e => this.onChange(e)}
            />
            <TextField
              id="project"
              label="Brief Description of Project"
              fullWidth={true}
              margin="normal"
              rows={3}
              multiline
              value={formdata.project}
              onChange={e => this.onChange(e)}
            />

            <Button
              color={'secondary'}
              style={{ background: '#924B94' }}
              variant={'raised'}
              className={classes.feedbackFormSubmit}
              onClick={() => this.submitForm()}
            >
              Submit Enquiry
            </Button>
          </form>
        </div>
      </div>
    )
  }
}

export default withStyles(styles)(Enquiry)



// WEBPACK FOOTER //
// ./src/components/enquiry/index.js